import React from "react";

const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "support@aicosts.ai";

/**
 * Rendered by the top-level Sentry ErrorBoundary when a render crash takes the
 * dashboard down. The error itself has already been reported by the time this
 * shows, so this only needs to give the user a way forward.
 */
const AppCrashFallback: React.FC = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.75rem",
      padding: "2rem",
      textAlign: "center",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}
  >
    <h1 style={{ fontSize: "1.5rem", margin: 0 }}>Something went wrong</h1>
    <p style={{ margin: 0, color: "#555", maxWidth: "32rem" }}>
      The page hit an unexpected error and our team has been notified. Reloading
      usually clears it.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        marginTop: "0.5rem",
        padding: "0.6rem 1.25rem",
        borderRadius: "0.5rem",
        border: "none",
        background: "#111",
        color: "#fff",
        cursor: "pointer",
        fontSize: "0.95rem",
      }}
    >
      Reload page
    </button>
    <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
      Still stuck? Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
    </p>
  </div>
);

export default AppCrashFallback;
